<script lang="ts" module>
  import type { TeoNotificationButton } from '@/teoCore/TeoNotifications';
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';

  import { useNotificationActions } from '../use-notification.svelte';

  export interface NotificationButtonProps extends TeoNotificationButton {
    notificationId: number;
  }
</script>

<script lang="ts">
  let { closeNotification } = useNotificationActions();
  let { label, notificationId, onclick, variant = 'cta' }: NotificationButtonProps = $props();

  function handleClick() {
    const result = typeof onclick === 'function' ? onclick() : onclick;
    if (result === 'keep') {
      // do nothing keep the alert open
      return;
    } else if (typeof result === 'string' && result.startsWith('#teo/')) {
      // TODO add the action thingy;
    } else if (result) {
      console.warn('AlertButton unhandled result', result);
    }
    closeNotification(notificationId);
  }
</script>

<CtaButton {variant} onclick={handleClick}>{label}</CtaButton>
